var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeminiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130.3 130.3",
    style: {
      enableBackground: "new 0 0 130.3 130.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#26DDF9;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.1,2.4c-22,0-40.7,16.9-43,38.6c-21.7,2.3-38.6,21-38.6,43c0,23.9,19.4,43.3,43.3,43.3 c22,0,40.7-16.9,43-38.6c21.7-2.3,38.6-21,38.6-43C127.3,21.8,107.9,2.4,84.1,2.4z M117.2,50.5C115,65,103.4,76.6,89,78.8V50.5 H117.2z M12.6,79.1C14.7,64.7,26.3,53,40.8,50.9v28.2H12.6z M78.8,88.9c-2.4,16.4-16.4,28.6-33.1,28.6S15,105.3,12.6,88.9H78.8z  M79.2,50.5v28.6H50.6V50.5H79.2z M117.2,40.8H50.9c2.4-16.4,16.4-28.6,33.1-28.6C100.8,12.2,114.8,24.4,117.2,40.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeminiIcon);
export default __webpack_public_path__ + "static/media/gemini_icon.1cabaec4abeca5ed64afe50f5c51fcbb.svg";
export { ForwardRef as ReactComponent };